import { NetworkUrlOfChainId, EthRPCEndpoints, ChainType, ThetaRPCEndpoints } from 'common/constants';
const host = 'https://explorer.thetatoken.org';
const hostApi = 'https://explorer-api.thetatoken.org';
const hostWs = 'https://explorer-ws.thetatoken.org';
const config = {
    restApi: {
        host: hostApi,
        port: 443
    },
    socketApi: {
        host: hostWs,
        port: 443
    },
    defaultThetaChainID: NetworkUrlOfChainId[host],
    ethRPCEndpoint: EthRPCEndpoints[host],
    thetaRPCEndPoint: ThetaRPCEndpoints[host],
    chainInfo: {
        metachain: {
            host: "https://metachain-explorer.thetatoken.org"
        },
        mainchain: {
            name: 'Theta Main Chain',
            description: 'The Main Chain serves as the Metachain Hub and coordinates the Subchains.',
            host: 'https://explorer.thetatoken.org',
            hostApi: 'https://explorer-api.thetatoken.org',
            hostWs: 'https://explorer-ws.thetatoken.org',
            logoName: "theta",
            restApiPort: 443,
            socketApiPort: 443
        },
        subchains: [{
            name: 'TPulse Subchain',
            description: 'Powering transparency across Theta EdgeCloud Every compute, every prompt, every insight - on chain.',
            host: 'https://tsub68967-explorer.thetatoken.org',
            hostApi: 'https://tsub68967-explorer-api.thetatoken.org',
            hostWs: 'https://tsub68967-explorer-ws.thetatoken.org',
            logoName: "tpulse",
            restApiPort: 443,
            socketApiPort: 443
        }, {
            name: 'Lavita AI Subchain',
            description: 'Lavita AI subchain, powers the first blockchain-AI based health information marketplace aiming to revolutionize the way 8 billion individuals around the world diagnose, analyze and treat health and genomic issues, leading to earlier intervention and improved outcome.',
            host: 'https://tsub360890-explorer.thetatoken.org',
            hostApi: 'https://tsub360890-explorer-api.thetatoken.org',
            hostWs: 'https://tsub360890-explorer-ws.thetatoken.org',
            logoName: "lavita",
            restApiPort: 443,
            socketApiPort: 443
        }, {
            name: 'Passaways Subchain',
            description: 'Custom-built for the Passaways/PLASM ecosystem on Theta. Governed by PLASM.',
            host: 'https://tsub7734-explorer.thetatoken.org',
            hostApi: 'https://tsub7734-explorer-api.thetatoken.org',
            hostWs: 'https://tsub7734-explorer-ws.thetatoken.org',
            logoName: "passaways",
            restApiPort: 443,
            socketApiPort: 443
        }, {
            name: 'Grove Subchain',
            description: 'GROVE subchain powers the next-gen GroveWars Web3 gaming ecosystem and 3D Character Builder.',
            host: 'https://tsub47683-explorer.thetatoken.org',
            hostApi: 'https://tsub47683-explorer-api.thetatoken.org',
            hostWs: 'https://tsub47683-explorer-ws.thetatoken.org',
            logoName: "grove",
            restApiPort: 443,
            socketApiPort: 443
        }]
    },
    chainName: 'Theta Main Chain',
    chainType: ChainType.MAINCHAIN,
    tokenMap: {
        TFuelTransfer: ['0x4c19bbe3272b3b91afc395b80b60c4e9d33343df', '0x985ce67e6cf14827eb77ec4beb465cc223824f36', '0xcd432b9725a61294d69b58d5e76e4f61339f3235', '0xf103ae3dd74aaacb5cb65a323cbdd207b4598fc4'],
    }
};
export default config;
